import React from 'react'
import UniversityDisciplines from '../../components/services/studyabroad/UniversityDisciplines'
import WhyStudyAbroad from '../../components/services/studyabroad/WhyStudyAbroad'
import ContactSection from '../../components/JobsPage/ContactSection'


const StudyAbroadPage = () => {
  return (
   <main>
    <WhyStudyAbroad/>
  <UniversityDisciplines/>
  <ContactSection/>
   </main>
  )
}

export default StudyAbroadPage